export default "/_next/static/images/c537e41d1368879239683f72cdb67cad.svg";